import axios, { type AxiosInstance, type InternalAxiosRequestConfig } from 'axios';
import qs from 'qs';
import type { Auth0ContextInterface } from '@auth0/auth0-react';

export const createApiInstance = (getAccessTokenSilently: Auth0ContextInterface['getAccessTokenSilently']): AxiosInstance => {
    const axiosInstance = axios.create({
        baseURL: import.meta.env.VITE_API_URL,
        paramsSerializer: (params) => {
            return qs.stringify(params, { indices: false, arrayFormat: 'repeat' });
        },
    });

    axiosInstance.interceptors.request.use(async (request: InternalAxiosRequestConfig) => {
        const token = await getAccessTokenSilently();
        request.headers.Authorization = `Bearer ${token}`;

        return request;
    });

    axiosInstance.interceptors.request.use((request: InternalAxiosRequestConfig) => {
        request.headers.set('X-Correlation-ID', crypto.randomUUID());
        return request;
    });

    return axiosInstance;
};
